import React, { ReactElement } from 'react';
import { NotFoundPage } from 'slovlex-idsk-react-components';
import SecuredPageComponent from './component/SecuredPageComponent';
import { useUserContext } from '../../context/UserContext';
import { UserRoleEnum } from '../../model/currentuser/UserRole';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRoleEnum>;
  requestStatus?: number;
  additionalCheck?: boolean;
  hasOpravneniePracovneKroky?: boolean;
}

const SecuredPage = ({
  children,
  allowForRoles,
  requestStatus,
  additionalCheck,
  hasOpravneniePracovneKroky,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  if (requestStatus === 404) {
    return <NotFoundPage />;
  }

  return (
    <SecuredPageComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      additionalCheck={additionalCheck}
      hasOpravneniePracovneKroky={hasOpravneniePracovneKroky}
    >
      {children}
    </SecuredPageComponent>
  );
};

export default SecuredPage;
